import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
export var getMinMaxRange = function getMinMaxRange(value) {
  var _value$split = value.split('&'),
    _value$split2 = _slicedToArray(_value$split, 2),
    minStr = _value$split2[0],
    maxStr = _value$split2[1];
  var minValue = minStr ? minStr.split('=')[1] : null;
  var maxValue = maxStr ? maxStr.split('=')[1] : null;
  return {
    min: minValue ? parseInt(minValue, 10) : null,
    max: maxValue ? parseInt(maxValue, 10) : null
  };
};
export var getSelectedRangeFilter = function getSelectedRangeFilter(list, min, max) {
  return list.find(function (item) {
    var _item$range = item.range,
      _minV = _item$range.min,
      _maxV = _item$range.max;
    return min === _minV && max === _maxV;
  }) || {};
};